import { DataService } from '../../../services/data_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungGlossarZuordnungState {
    bundle: any;
    glossar: any;
}

export class DatenverwaltungGlossarZuordnung extends React.Component<{}, DatenverwaltungGlossarZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            glossar: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        return field === 'glossar' && ((this.state.glossar || {})[value] || []).length > 1
            ? `${value} (${this.state.glossar[value].indexOf(data.glossar_orig || data.glossar) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        this.dataService.loadData(
            IDs.ENT_GLOSSAR, {}, {},
            (result: any) => {
                const glossar: Array<any> = (result || {})[IDs.ENT_GLOSSAR] || [];

                ((result || {})[IDs.ENT_GLOSSAR] || [])
                    .sort((a: any, b: any) => a.tid - b.tid)
                    .forEach((item: any) => {
                        if (typeof data[item.name] === 'undefined') {
                            data[item.name] = [];
                        }
                        data[item.name].push(item.tid);
                    });

                glossar.forEach((item: any, index: number) => {
                    const name: string = item.name || null;
                    glossar[index].name = data[name].length > 1
                        ? `${name} (${data[name].indexOf(item.tid) + 1})`
                        : name;
                });
                this.setState({ bundle: { glossar }, glossar: data });
            },
            IDs.MOD_ETOOL_ADMIN
        );
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_GLOSSAR_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.glossar = this.state.bundle.glossar || bundle.glossar}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_GLOSSAR_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp
            />
        );
    }
}
